var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.627,
    height: 16.879,
    viewBox: "0 0 18.627 16.879",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.234)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.153,4.545A2.158,2.158,0,0,1,12.1,1.493L10.608,0,0,10.608,1.493,12.1a2.158,2.158,0,0,1,3.053,3.053l1.493,1.493L16.645,6.038Zm-6.846,1.4-.692-.692.69-.69L9,5.258ZM9.692,7.332,9,6.64l.69-.69.692.692Zm1.385,1.385-.692-.692.69-.69.692.692Z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1c97ce",
    transform: "translate(-288.987 0.766)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M 303.8069152832031 6.113834857940674 C 301.9834899902344 6.113834857940674 300.5 4.630354881286621 300.5 2.806915044784546 C 300.5 0.9834750294685364 301.9834899902344 -0.4999949634075165 303.8069152832031 -0.4999949634075165 C 305.6303405761719 -0.4999949634075165 307.1138305664062 0.9834750294685364 307.1138305664062 2.806915044784546 C 307.1138305664062 4.630354881286621 305.6303405761719 6.113834857940674 303.8069152832031 6.113834857940674 Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fill: "#1c2e3e",
    d: "M 303.8069152832031 5.613834857940674 C 305.3571166992188 5.613834857940674 306.6138305664062 4.357144832611084 306.6138305664062 2.806915044784546 C 306.6138305664062 1.256685018539429 305.3571166992188 5.044784757046727e-06 303.8069152832031 5.044784757046727e-06 C 302.2566528320312 5.044784757046727e-06 301 1.256685018539429 301 2.806915044784546 C 301 4.357144832611084 302.2566528320312 5.613834857940674 303.8069152832031 5.613834857940674 M 303.8069152832031 6.613834857940674 C 301.707763671875 6.613834857940674 300 4.906054973602295 300 2.806915044784546 C 300 0.7077750563621521 301.707763671875 -0.9999949336051941 303.8069152832031 -0.9999949336051941 C 305.9060668945312 -0.9999949336051941 307.6138305664062 0.7077750563621521 307.6138305664062 2.806915044784546 C 307.6138305664062 4.906054973602295 305.9060668945312 6.613834857940674 303.8069152832031 6.613834857940674 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketsActive);
export default __webpack_public_path__ + "static/media/tickets-active.f9460e7e.svg";
export { ForwardRef as ReactComponent };